import {
  useParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useCallback } from 'react';

function useSearchParam(
  name: string,
  defaultValue: string,
): [string, (value: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentParam = searchParams.get(name);
  const value = currentParam ?? defaultValue;

  const updateValue = useCallback(
    (next: string) => {
      setSearchParams((prev) => {
        const p = new URLSearchParams(prev);
        p.set(name, next);
        return p;
      });
    },
    [name, setSearchParams],
  );

  return [value, updateValue];
}

export { useParams, useLocation, useNavigate, useSearchParams, useSearchParam };
